import { GridColDef, GridRenderCellParams, GridSortModel } from "@mui/x-data-grid";
import { ServerDataGrid, usePagination } from "components/ui/ServerDataGrid";
import { NonOpticPosition, useListNonOpticPositionsQuery } from "features/trading/accounts";
import { useState } from "react";

const NonOpticPositionsList = () => {
  const [pagination, setPagination] = usePagination(25);
  // Opens with no sort model, rather than the `useSorting` hook's one-item
  // default. The order the page has always opened in -- nearest expiry first,
  // then symbol -- is two terms deep, so no single header could show an arrow
  // that states what the rows actually do. An empty model leaves every header
  // unarrowed and the API's own default order standing, which is what the
  // reader already sees.
  const [sorting, setSorting] = useState<GridSortModel>([]);
  const { data, isLoading, isFetching } = useListNonOpticPositionsQuery({ pagination, sorting });
  const columns: GridColDef<NonOpticPosition>[] = [
    {
      field: "name",
      headerName: "Name",
      width: 250,
    },
    {
      field: "symbol",
      headerName: "Symbol",
      width: 250,
      renderCell: ({ value }: GridRenderCellParams) => {
        return (
          <pre>{value}</pre>
        );
      },
    },
    {
      field: "client_name",
      headerName: "Client Name",
      width: 250,
    },
    {
      field: "account_number",
      headerName: "Account #",
      width: 150,
    },
    {
      field: "custodian_name",
      headerName: "Custodian",
      width: 150,
    },
    {
      field: "option_qty",
      headerName: "Option Qty",
      type: "number",
      // The column menu button appears on hover and takes ~30px out of the
      // header, which at 150 leaves 82px for a label that needs 84 -- "Option
      // Qty" renders as "Option Qt...". It only mattered once the header became
      // worth hovering: 160 clears it, and the other five labels already fit.
      width: 160,
    },
  ].map((colDef: GridColDef) => ({ ...colDef, filterable: false }));

  return (
    <ServerDataGrid
      slots={{}}
      rows={data?.results || []}
      rowCount={data?.count || 0}
      loading={isLoading || isFetching}
      columns={columns}
      density="compact"
      paginationModel={pagination}
      sortModel={sorting}
      // Deliberately does not reset the page: a sort keeps the reader where
      // they are, matching the Orders table.
      onSortModelChange={setSorting}
      onPaginationModelChange={setPagination}
    />
  );
};

export default NonOpticPositionsList;
